import useIntl from "./useIntl";

export default function useFormatMessage(value) {
  const intl = useIntl();
  if (value) {
    return intl.formatMessage(value);
  }
  return intl.formatMessage;
}
